module.exports = __webpack_public_path__ + "static/media/ios-git-pull-request.ba4f8467.svg";